<template>
  <div class="dhr-sideview">
    <h4 class="content-subtitle">Approval info</h4>
    <div v-if="approver">
      <div class="shared shared-2">
        <div>
          <label>Operator: </label>
          <span>{{ approver.firstname + " " + approver.lastname }}</span>
        </div>
        <div>
          <label>Approval Date: </label>
          <span>{{ approvalData.date | formatDateTime }}</span>
        </div>
      </div>
      <div class="shared shared-2">
        <div>
          <label>F-100-01: </label>
          <span>{{ extraDetails.f10003 == true ? "OK" : "NOK" }}</span>
        </div>
        <div>
          <label>F-100-03: </label>
          <span>{{ extraDetails.f10003 == true ? "OK" : "NOK" }}</span>
        </div>
      </div>
      <div class="shared shared-2">
        <div>
          <label>Signature: </label>
          <img class="signatue" :src="approvalData.signature" />
        </div>
        <div>
          <label>Comment </label>
          <span>{{ extraDetails.comment }}</span>
        </div>
      </div>
    </div>
    <div v-else>
      <span class="no-data">{{
        !data.approved
          ? "This DHR hasn't been approved yet."
          : "No approval info found for this DHR."
      }}</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components: {
    BaseIcon,
  },
  props: {
    data: Object,
    approvalData: Object,
    approver: Object,
    isApproved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      extraDetails: {},
    };
  },
  mounted() {
    this.convertJSONapproval();
    this.approver;
  },
  methods: {
    convertJSONapproval() {
      this.extraDetails =
        this.data.approved == true ? JSON.parse(this.approvalData.comment) : {};
    },
  },
  watch: {
    data: {
      handler: function () {
        this.convertJSONapproval();
      },
    },
    approvalData: {
      handler: function () {
        this.convertJSONapproval();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";

label {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  color: #035362;
}
span {
  width: auto;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  text-align: left;
  color: #707070;
  margin: 10px 0;
}

.sign-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

img.signatue {
  margin-top: 10px;
  max-height: 88px;
}

.no-data {
  color: #6a6a6a;
  font-weight: 400;
  font-style: italic;
  padding-top: 16px;
}

.shared {
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  &-2 {
    & > div {
      width: 50%;
    }
  }
  div + div {
    margin-left: 20px;
  }
}
</style>